import React from "react";
import { Dots } from "react-dot-patterns";
import "./manufacturing.css";
import AutoTyping, { BlinkCursor } from "react-auto-typing";
import erpIcon from "../../../assets/erp-integration.svg";
import biometricIcon from "../../../assets/biometric-icon.svg";
import outsourcingIcon from "../../../assets/project_based_oursourcing.svg";
import machineVisionIcon from "../../../assets/machine-vision.svg";

const KeyFeatures = () => {
  return (
    <div className="manufacturing-features-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
        />
      </div>
      <div className="section-title">
        <h1 className="title">Key Features</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Features"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="features-details-container">
        <div className="features-details">
          <div className="row mt-12x gutter-y-6x">
            <div className="col-12 col-sm-6 col-md-3">
              <div className="card features-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                <span className="card__icon-main card__icon purple">
                  <img src={erpIcon} alt="icon" width="48" height="48" />
                </span>
                <p className="fs-lead card__title undefined">
                  Real-time Inventory Management with CUBIX
                </p>
                <div className="card__body">
                  <p>
                    Track raw materials, manage finished goods, and optimize
                    inventory turnover with real-time visibility into stock
                    levels and order statuses.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <div className="card features-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                <span className="card__icon-main card__icon green">
                  <img src={biometricIcon} alt="icon" width="48" height="48" />
                </span>
                <p className="fs-lead card__title undefined">
                  Asset Lifecycle Management with Trackline
                </p>
                <div className="card__body">
                  <p>
                    Monitor and maintain machinery, equipment, and tools to
                    prevent downtime and extend asset life, ensuring continuous
                    production.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <div className="card features-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                <span className="card__icon-main card__icon blue">
                  <img
                    src={outsourcingIcon}
                    alt="icon"
                    width="48"
                    height="48"
                  />
                </span>
                <p className="fs-lead card__title undefined">
                  Production Workflow Automation
                </p>
                <div className="card__body">
                  <p>
                    Streamline production processes from order management to
                    product assembly and delivery, increasing throughput and
                    reducing waste.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3">
              <div className="card features-card card--white icon-bg-light-grey card--top-margin has-icon-circle">
                <span className="card__icon-main card__icon purple">
                  <img
                    src={machineVisionIcon}
                    alt="icon"
                    width="48"
                    height="48"
                  />
                </span>
                <p className="fs-lead card__title undefined">
                  Compliance & Regulatory Reporting
                </p>
                <div className="card__body">
                  <p>
                    Stay up to date with regulatory requirements using automated
                    tools that ensure compliance with industry standards and
                    safety protocols.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyFeatures;
